<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'

export default {

  data () {
    return {
      locale: zhCN
    }
  },
  created () {

  },
  mounted () {
  }
}
</script>
<style lang="less">
  #app {
    height: 100%;
  }
.resize-table-th {
  position: relative;
  .table-draggable-handle {
    position: absolute;
    height: 100% !important;
    bottom: 0;
    left: -5px;
    cursor: col-resize;
    touch-action: none;
  }
}
.ant-table-tbody .ant-table-row-cell-break-word{
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
</style>
